export default "__VITE_ASSET__af42a51f__"